import Card from '@mui/material/Card';
import { CardHeader, CardContent, Backdrop, CircularProgress, Snackbar, Grid, Button, Divider, TextField, Box, Tooltip, IconButton, Chip } from '@mui/material';
import { useNavigate } from 'react-router';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import Alert from 'src/components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from 'moment';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

function SarisDynamicWarranty() {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(false);
  const [dynamicWarrantyData, setDynamicWarrantyData] = React.useState([]);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [warrantyType, setWarrantyType] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    handleGetSarisDynamicWarranty();
  }, []);

  const handleGetSarisDynamicWarranty = () => {
    setLoading(true);
    axios
      .get(`GetSarisDynamicWarranty`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setDynamicWarrantyData(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const HandleInsertWarrantyType = () => {
    if (warrantyType.length > 10) {
      setresponseMessage('Garanti Tipi 10 karakterden büyük olamaz !');
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);
    axios
      .get(`SetSarisDynamicNewWarranty/${warrantyType}/${description}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicWarranty();
          setWarrantyType('');
          setDescription('');
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };
  const deleteDynamicWarrantyType = (KulKodu, GarantiTipi, Acıklama) => {
    confirmAlert({
      message: 'Silmek istediğinizde emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            handleDeleteDynamicWarrantyType(KulKodu, GarantiTipi, Acıklama);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const handleDeleteDynamicWarrantyType = (KulKodu, GarantiTipi, Acıklama) => {
    setLoading(true);
    axios
      .get(
        `SetSarisDynamicWarrantyTypeDelete/${KulKodu}/${GarantiTipi}/${Acıklama}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicWarranty();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const SarisDynamicWarrantyDetail = row => {
    const { GARANTI_TIPI, ACIKLAMA, KUL_GARANTI_TIPI } = row;
    navigate(`/WarrantyTypeDetail/${GARANTI_TIPI}/${ACIKLAMA}`);
  };

  const columns = [
    {
      field: 'KUL_GARANTI_TIPI',
      headerName: 'Garanti Tipi',
      width: 300,
      headerAlign: 'center',
      align: 'center',
      renderCell: params => (
        <Chip
          label={params.row.KUL_GARANTI_TIPI}
          size="small"
          variant="outlined"
          clickable
          onClick={() => SarisDynamicWarrantyDetail(params.row)}
        />
      )
    },
    {
      field: 'ACIKLAMA',
      headerName: 'Açıklama',
      width: 400,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'SICILNO',
      headerName: 'Kullanıcı Kodu',
      width: 350,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'ADSOYAD',
      headerName: 'Kullanıcı',
      width: 300,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'TARIH',
      headerName: 'Oluşturulma Tarihi',
      width: 400,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const date1 = new Date(v1).getTime();
        const date2 = new Date(v2).getTime();
        return date1 - date2;
      },
      renderCell: params => {
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    },
    {
      field: 'Sil',
      headerName: '',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: cellValues => {
        return (
          <Tooltip title="Sil">
            <IconButton
              size="small"
              onClick={() =>
                deleteDynamicWarrantyType(
                  cellValues?.row?.KUL_KODU,
                  cellValues?.row?.GARANTI_TIPI,
                  cellValues?.row?.ACIKLAMA
                )
              }
            >
              <DeleteIcon style={{ color: '#FF9800' }} />
            </IconButton>
          </Tooltip>
        );
      },
      width: 80
    }
  ];

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader title="Dinamik Garanti" />
        <Divider />
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Garanti Tipi"
                variant="outlined"
                size="small"
                value={warrantyType}
                onChange={e => setWarrantyType(e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Açıklama"
                variant="outlined"
                size="small"
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </Grid>
            <Grid size={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    HandleInsertWarrantyType();
                  }}
                >
                  Ekle
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3, height: 600, width: '100%' }}>
            <DataGrid
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 700,
                  color: 'text.primary'
                },
                '& .MuiDataGrid-cell': {
                  color: 'text.primary'
                }
              }}
              rows={dynamicWarrantyData}
              columns={columns}
              getRowId={rows => rows.GARANTI_TIPI}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 }
                }
              }}
              pageSizeOptions={[10, 25, 50]}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { placeholder: 'Ara...' }
                }
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default SarisDynamicWarranty;
